import { z } from "zod";

export const InitiatePasswordRecoveryResponseSchema = z.object({
	guest_id: z.number(),
	message: z.string(),
});

export type InitiatePasswordRecoveryResponse = z.infer<
	typeof InitiatePasswordRecoveryResponseSchema
>;

export const VerifyCodeResponseSchema = z.object({
	access_token: z.string(),
});

export type VerifyCodeResponse = z.infer<typeof VerifyCodeResponseSchema>;
